export default __webpack_public_path__ + "static/media/notes1.f53bc1f8.svg";